import React from 'react';
import { useSelector } from 'react-redux';

import { Select, Input, Flex, Space, Checkbox, Typography } from 'antd';

import { getAsNumber } from '../../../../../../utilities/numberConvertion';
import AttachmentModal from '../../../../../../components/Modal/AttachmentModal';

const { Text } = Typography;

export const TableCol = (handleSave, status) => {
  const _static = useSelector((state) => state.static);
  const { staticData } = _static;
  const { academic_responsibilities_roles: academicResponsibilitiesRoles } = staticData;

  const oncePerCycle = academicResponsibilitiesRoles.filter((item) => item.once_per_cycle);
  // const oncePerSemester = academicResponsibilitiesRoles?.filter((item) => item.once_per_semester);

  return [
    {
      key: 'role',
      dataIndex: 'role',
      title: 'Role/ Responsibility',
      render: (value, row) => {
        const _roles = academicResponsibilitiesRoles?.filter((item) => item.id === value);
        const _role = _roles[0];

        return (
          <Select
            style={{ width: '420px', minHeight: '64px' }}
            options={[
              ...academicResponsibilitiesRoles.map((role) => ({
                value: role.id,
                label: role ? (
                  <Flex vertical>
                    <Text>{role.role}</Text>
                    {role.rule ? (
                      <Text
                        type="secondary"
                        style={{
                          whiteSpace: 'normal',
                          wordWrap: 'break-word',
                          maxWidth: '400px',
                        }}
                      >({role.rule})</Text>
                    ) : (
                      ''
                    )}
                  </Flex>
                ) : (
                  <></>
                )
              }))
            ]}
            defaultValue={_role.id}
            placeholder="Select a Role"
            disabled={status === 1 || status === 2 || status === 3}
            onChange={(e) => {
              const _oncePerCycle = oncePerCycle.filter(
                (item) => item.id === e
              );
              const isOncePerCycle = _oncePerCycle && _oncePerCycle.length;

              const updatedRow = !isOncePerCycle
                ? {
                  ...row,
                  nodal: [],
                  apa_cycle: false,
                  role: e
                }
                : { ...row, role: e };
              handleSave(updatedRow);
            }}
          />
        );
      }
    },
    {
      key: 'count',
      dataIndex: 'count',
      title: 'Count',
      render: (value, row) => {
        const _oncePerCycle = oncePerCycle?.filter((item) => item.id === row.role);

        return _oncePerCycle && _oncePerCycle.length ? (
          ''
        ) : (
          <Input
            placeholder="Enter"
            value={row?.count}
            disabled={status === 1 || status === 2 || status === 3}
            onChange={(e) => {
              const updatedCount = getAsNumber(e.target.value);
              handleSave({
                ...row,
                count: updatedCount
              });
            }}
          />
        );
      }
    },

    {
      key: 'modal',
      dataIndex: 'modal',
      title: 'Attachments',
      render: (value, row) => {
        const title = 'Spring';

        const _oncePerCycle = oncePerCycle?.filter((item) => item.id === row.role);

        return _oncePerCycle && _oncePerCycle.length ? (
          ''
        ) : (
          <Space>
            {/* <Input
                placeholder="Enter"
                value={row?.count}
                disabled={status === 1 || status === 2 || status === 3}
                onChange={(e) => {
                  const updatedCount = getAsNumber(e.target.value);

                  handleSave({
                    ...row,
                    count: updatedCount,
                    modal: row?.modal
                  })
                }
                }
              /> */}
            <AttachmentModal
              row={row}
              action={handleSave}
              parentKey="modal"
              title={title}
              disabled={status === 1 || status === 2 || status === 3}
              status={status}
            />
          </Space>
        );
      }
    },
    {
      key: 'apa_cycle',
      dataIndex: 'apa_cycle',
      title: 'APA Cycle',
      render: (value, row) => {
        const _oncePerCycle = oncePerCycle.filter(
          (item) => item.id === row.role
        );
        return !(_oncePerCycle && _oncePerCycle.length) ? (
          ''
        ) : (
          <Checkbox
            placeholder="Enter"
            // defaultChecked={value}
            checked={value}
            disabled={status === 1 || status === 2 || status === 3}
            onChange={(e) =>
              handleSave({ ...row, apa_cycle: e.target.checked })
            }
          />
        );
      }
    }
  ];
};
